angular.module('ui.order.orderItemsGridSharedSettings', [])

    // Shared settings for order item grid and order item list
    .service('orderItemsGridSharedSettings', function ($localStorage) {

        // Subscribers of Observer pattern
        // We use observers cause Angular doesn't track changes of $scope from 3rd party
        var subscribers = {};

        // todo: comments for getters/setters
        // todo: 'changed' flag for gridDataProvider cache

        var _this = this;

        /**
         * Additional filter: step
         * @type {string}
         */
        var stepFilter;

        /**
         * Custom filter configuration object to filter order items. Contains all metadata describing custom filtering procedure.
         * Can be used by the orderItemsGridView by triggering the shared settings object to see if the customer filter applied from the customisation config or not.
         * @type {{name: string, color: string, queryForStatInfo: string, targetUri: string, iconName: string, uiPriority: int}}
         */
        var customFilter = null;

        /**
         * Additional filter: completed
         * @type {{from: Date, to: Date, enabled: boolean}}
         */
        var completedFilter;

        /**
         * Additional filter: created
         * @type {{from: Date, to: Date, enabled: boolean}}
         */
        var createdFilter;

        /**
         * Additional filter: text search
         * @type {{text: string, exact: boolean}}
         */
        var textSearch;

        /**
         * Page number. 1-based
         * @type {number}
         */
        var pageNumber;

        /**
         * Total Page Count
         * @type {number}
         */
        var totalPageCount;

        /**
         * Page size
         * @type {number}
         */
        var pageSize;

        var PAGE_SIZE_FOR_STEP_FILTER_PREFIX = "Grid-Page-Size-For-Step-";

        /**
         * Total Count
         * @type {number}
         */
        var totalCount;

        /**
         * Main grid filter
         */
        var gridFilter;

        /**
         * Main grid sorting
         */
        var gridSort;

        /**
         * Selected order Item Ids
         * @type {string}
         */
        var selectedOrderItemIds = [];

        var isExclusiveSelection = false;

        /**
         * Flag to indicate that we want to force ignore of the specified page size
         * @type {boolean}
         */
        var forceIgnorePage = false;

        _.extend(_this, {
            setStepFilter: setStepFilter,
            getStepFilter: getStepFilter,

            setCustomFilter: setCustomFilter,
            getCustomFilter: getCustomFilter,

            setCompletedFilter: setCompletedFilter,
            getCompletedFilter: getCompletedFilter,

            setCreatedFilter: setCreatedFilter,
            getCreatedFilter: getCreatedFilter,

            setTextSearch: setTextSearch,
            getTextSearch: getTextSearch,

            setPageNumber: setPageNumber,
            getPageNumber: getPageNumber,

            setTotalPageCount: setTotalPageCount,
            getTotalPageCount: getTotalPageCount,

            setPageSize: setPageSize,
            getPageSize: getPageSize,

            setTotalCount: setTotalCount,
            getTotalCount: getTotalCount,

            setGridFilter: setGridFilter,
            getGridFilter: getGridFilter,

            setGridSort: setGridSort,
            getGridSort: getGridSort,

            setForceIgnorePageSize: setForceIgnorePageSize,
            getForceIgnorePageSize: getForceIgnorePageSize,

            setSelectedOrderItemIds: setSelectedOrderItemIds,
            getSelectedOrderItemIds: getSelectedOrderItemIds,

            setSelectedOrderItemId: setSelectedOrderItemId,
            getSelectedOrderItemId: getSelectedOrderItemId,

            getIsExclusiveSelection: getIsExclusiveSelection,
            setIsExclusiveSelection: setIsExclusiveSelection,

            clear: clear,
            isClear: isClear,

            onSelectionChange: onSelectionChange
        });

        return _this;

        //region Observer pattern

        function onSelectionChange(subscriberName, cb) {
            subscribers[subscriberName] = cb;
        }

        function selectionWasChanged() {
            _.forEach(subscribers, function (callback) {
                if (callback && _.isFunction(callback)) {
                    callback();
                }
            });
        }

        //endregion

        function clear() {
            setStepFilter(null);
            setTextSearch(null);
            setCompletedFilter(null);
            setCreatedFilter(null);
            setPageNumber(1);
            setGridFilter(null);
            setGridSort(null);
            setTotalPageCount(0);
            setTotalCount(0);
            setSelectedOrderItemIds(null);
            setForceIgnorePageSize(false);
        }

        /**
         * Check if there was no filters/sorters
         */
        function isClear() {
            return (!completedFilter || !completedFilter.enabled || (!completedFilter.from && !completedFilter.to))
                && (!createdFilter || !createdFilter.enabled || (!createdFilter.from && !createdFilter.to))
                && (!textSearch || !textSearch.text || textSearch.text.length <= 0)
                && !gridFilter
                && !gridSort;
        }

        //region Getters and setters

        function setForceIgnorePageSize(_ignore) {
            forceIgnorePage = _ignore;
        }

        function getForceIgnorePageSize() {
            return forceIgnorePage;
        }

        function setStepFilter(_step) {
            if (!_.isEqual(stepFilter, _step)) {
                stepFilter = _.clone(_step);
                _this.setGridFilter(null);
                _this.setGridSort(null);
                _this.setPageSize(null); //reset the page size so we can read it from the saved to localStorage value for each Step filter (view) accordingly
                _this.setPageNumber(1);
            }
            //Reset exclusive-mode anyway even if it is the same step. 
            //i.e.: This is useful when user want to navigate to the 'whole step overview' up from 'single item view')
            _this.setIsExclusiveSelection(false);
        }

        function getStepFilter() {
            return _.clone(stepFilter);
        }

        /**
         * Sets custom filter config
         * @param {{name: string, color: string, queryForStatInfo: string, targetUri: string, iconName: string, uiPriority: int}} [_customFilter] Custom filter config
         * @constructor
         */
        function setCustomFilter(_customFilter) {
            customFilter = _customFilter !== null ? _.clone(_customFilter) : null;
            _this.setGridFilter(null);
            _this.setGridSort(null);
            _this.setPageSize(null); //reset the page size so we can read it from the saved to localStorage value for each Step filter (view) accordingly
            _this.setPageNumber(1);

            //Reset exclusive-mode anyway even if it is the same step. 
            //i.e.: This is useful when user want to navigate to the 'whole step overview' up from 'single item view')
            _this.setIsExclusiveSelection(false);
        }

        function getCustomFilter() {
            return _.clone(customFilter);
        }

        /**
         * Sets completed filter config
         * @param {{from: Date, to: Date, enabled: boolean}} [_completed] Order items completion filter config
         * @constructor
         */
        function setCompletedFilter(_completed) {
            completedFilter = _.clone(_completed);
        }

        function getCompletedFilter() {
            return _.clone(completedFilter);
        }

        function setCreatedFilter(_created) {
            createdFilter = _.clone(_created);
        }

        function getCreatedFilter() {
            return _.clone(createdFilter);
        }

        function setTextSearch(_text, _exactMatch) {
            textSearch = {
                text: _text,
                exact: _exactMatch
            };
        }

        function getTextSearch() {
            return _.clone(textSearch);
        }

        function setPageNumber(_pageNumber) {
            pageNumber = _pageNumber;
        }

        function getPageNumber() {
            return pageNumber;
        }

        function setTotalPageCount(_totalPageCount) {
            totalPageCount = _totalPageCount;
        }

        function getTotalPageCount() {
            return totalPageCount;
        }

        function setPageSize(_pageSize) {
            pageSize = _pageSize;

            //Also store the page number for the current step filter
            //so later we can return the saved one
            if (stepFilter && stepFilter !== '' && stepFilter != null && pageSize != null) {
                $localStorage.setItem(PAGE_SIZE_FOR_STEP_FILTER_PREFIX + stepFilter, pageSize);
            }
        }

        function getPageSize() {
            if (!pageSize || pageSize == null) {
                if (stepFilter && stepFilter !== '') {
                    pageSize = $localStorage.getItem(PAGE_SIZE_FOR_STEP_FILTER_PREFIX + stepFilter);
                }
            }

            return pageSize;
        }

        function setTotalCount(_totalCount) {
            totalCount = _totalCount;
        }

        function getTotalCount() {
            return totalCount;
        }

        function setGridFilter(_gridFiler) {
            gridFilter = _.clone(_gridFiler);
        }

        function getGridFilter() {
            return _.clone(gridFilter);
        }

        function setGridSort(_gridSort) {
            if (_gridSort != null) {
                gridSort = _.clone(_gridSort);
            } else {
                gridSort = [{field: "$model.created", dir: "desc"}];
            }
        }

        function getGridSort() {
            return _.clone(gridSort);
        }

        function setSelectedOrderItemIds(ids) {
            selectedOrderItemIds = ids;
            selectionWasChanged();
        }

        function setSelectedOrderItemId(id, _isExclusiveSelection) {
            selectedOrderItemIds = [id];
            selectionWasChanged();

            if (_isExclusiveSelection && _isExclusiveSelection === true) {
                isExclusiveSelection = true;
            }
        }

        function getSelectedOrderItemIds() {
            if (!selectedOrderItemIds) {
                return [];
            }
            return selectedOrderItemIds;
        }

        function getSelectedOrderItemId() {
            if (!selectedOrderItemIds) {
                return null;
            }
            return selectedOrderItemIds[0];
        }

        function getIsExclusiveSelection() {
            return !!isExclusiveSelection;
        }
        function setIsExclusiveSelection(_isExclusiveSelection) {
            isExclusiveSelection = _isExclusiveSelection;
        }

        //endregion
    })

;
